import React, { useState } from 'react';

import './App.css';
import {AddCategory , GifGrid} from './components'; //archivo barril

// import { AddCategory } from './components/AddCategory';
// import { GifGrid } from './components/GifGrid';

function App() {

  const [categories, setCategories] = useState([ 'Landscape' ])

  const onAddCategory = (newCategory)=>{

    if(categories.includes(newCategory)) return;
    setCategories([newCategory , ...categories]);
  }
  return (
    <>
      {/* titulo */}
      <h1>Gif expertApp</h1>

      {/* imput */}
      <AddCategory 
        onNewCategory={ event => onAddCategory(event) }
      />


        { categories.map((cat)=> (
              <GifGrid key={cat} category={cat}/>
            )
        )}


      {/* gifItem */}
    </>
  );
}

export default App;
